import React, { useState } from 'react';
import { ThreeDotsVerticalIcon } from 'src/assets/Images';
import { IconButton, Icon, MenuWrapper, Menu, MenuItem } from './styles';
var KebabMenu = function (_a) {
    var onSelect = _a.onSelect;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    return (React.createElement(MenuWrapper, null,
        React.createElement(IconButton, { type: "button", "aria-label": "M\u00E1s opciones", title: "M\u00E1s opciones", onClick: function () { return setOpen(function (prevState) { return !prevState; }); } },
            React.createElement(Icon, { src: ThreeDotsVerticalIcon, alt: "M\u00E1s opciones" })),
        open && (React.createElement(Menu, null,
            React.createElement(MenuItem, { onClick: function () { setOpen(false); onSelect === null || onSelect === void 0 ? void 0 : onSelect('authorize_payment'); } }, "Autorizar Pago"),
            React.createElement(MenuItem, { onClick: function () { setOpen(false); onSelect === null || onSelect === void 0 ? void 0 : onSelect('create_claim'); } }, "Realizar Reclamo"),
            React.createElement(MenuItem, { onClick: function () { setOpen(false); onSelect === null || onSelect === void 0 ? void 0 : onSelect('request_budget'); } }, "Pedir Presupuesto")))));
};
export default KebabMenu;
